import React from "react";
import { ReactComponent as PencilInlineButton } from "resources/icons/PencilSimpleLine.svg";

const NovaConversationTitle = (novaHeaderProps) => {
  const {
    conversationTitle,
    hovered,
    isEditing,
    tempTitle,
    setTempTitle,
    setIsEditing,
    handleRename,
    inputRef,
    handleRenameByPress,
  } = novaHeaderProps;
  return (
    <>
      {isEditing ? (
        <input
          ref={inputRef}
          value={tempTitle}
          onChange={(e) => setTempTitle(e.target.value)}
          onBlur={handleRename}
          onKeyDown={handleRenameByPress}
          className="rename-editor"
        />
      ) : (
        <div className="flex items-center justify-between">
          <span className="mr-30 w-90 ellipsis" title={conversationTitle}>
            {conversationTitle}
          </span>
          {hovered && (
            <PencilInlineButton
              className="mt-5 cursor-pointer"
              title="Rename"
              onClick={() => setIsEditing(true)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default NovaConversationTitle;
